import React from "react";

const Footer = () => {
  const mail = window.location.host.includes("rgdrone.co.il")
    ? "info@rgdrone.co.il"
    : "info@rgdrone.com";
  const fb = "https://www.facebook.com/profile.php?id=61573263890457#";

  return (
    <footer className="footer">
      <a href="#home" className="logo">
        <img src="/logo.png" alt="1" />
      </a>
      <div className="post">
        <a href={"mailto:" + mail}>
          <img src="/mail.png" alt="mail" />
        </a>
        <a href="https://wa.me/972505881158" target="_blank" rel="noreferrer">
          <img src="/wa.png" alt="wa" />
        </a>
        <a
          href={fb}
          target="_blank"
          rel="noreferrer"
          style={{ position: "relative", top: -3 }}
        >
          <img src="/fb.png" alt="fb" style={{ width: 33, height: 33 }} />
        </a>
        <a
          href={
            "https://www.instagram.com/rg.drone1?igsh=c3MwdDRmdDVxbnRx&utm_source=qr"
          }
          target="_blank"
          rel="noreferrer"
          style={{ position: "relative", top: -3 }}
        >
          <img
            src="/instagram.png"
            alt="in"
            style={{ width: 46, height: 46, margin: "-7px 2px" }}
          />
        </a>
      </div>
      <div>
        © <span className="text-bold">RG DRONE</span> All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
